import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { LayoutDashboard, SproutIcon, Search, Users, Briefcase, LineChart, Calendar, Settings, HelpCircle, FileText, DollarSign, ChevronRight, ChevronDown } from 'lucide-react';
export const Sidebar = () => {
  const location = useLocation();
  const {
    userType
  } = useUser();
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);
  // Define navigation items based on user type
  const getNavigationItems = () => {
    const adminNavItems = [{
      name: 'Dashboard',
      path: '/admin/dashboard',
      icon: <LayoutDashboard size={20} data-id="element-362" />
    }, {
      name: 'Projects',
      path: '/admin/projects',
      icon: <SproutIcon size={20} data-id="element-363" />,
      subItems: [{
        name: 'All Projects',
        path: '/admin/projects'
      }, {
        name: 'Add Project',
        path: '/admin/projects/add'
      }, {
        name: 'Categories',
        path: '/admin/projects/categories'
      }]
    }, {
      name: 'Users',
      path: '/admin/users',
      icon: <Users size={20} data-id="element-364" />,
      subItems: [{
        name: 'Farmers',
        path: '/admin/users/farmers'
      }, {
        name: 'Investors',
        path: '/admin/users/investors'
      }]
    }, {
      name: 'Finance',
      path: '/admin/finance',
      icon: <DollarSign size={20} data-id="element-365" />,
      subItems: [{
        name: 'Transactions',
        path: '/admin/finance/transactions'
      }, {
        name: 'Repayments',
        path: '/admin/finance/repayments'
      }]
    }, {
      name: 'Reports',
      path: '/admin/reports',
      icon: <FileText size={20} data-id="element-366" />
    }, {
      name: 'Settings',
      path: '/admin/settings',
      icon: <Settings size={20} data-id="element-367" />
    }];
    const investorNavItems = [{
      name: 'Dashboard',
      path: '/investor/dashboard',
      icon: <LayoutDashboard size={20} data-id="element-368" />
    }, {
      name: 'Discover',
      path: '/investor/discover',
      icon: <Search size={20} data-id="element-369" />
    }, {
      name: 'My Investments',
      path: '/investor/investments',
      icon: <Briefcase size={20} data-id="element-370" />
    }, {
      name: 'Repayments',
      path: '/investor/repayments',
      icon: <DollarSign size={20} data-id="element-371" />
    }, {
      name: 'Progress Updates',
      path: '/investor/progress',
      icon: <LineChart size={20} data-id="element-372" />
    }, {
      name: 'Calendar',
      path: '/investor/calendar',
      icon: <Calendar size={20} data-id="element-373" />
    }, {
      name: 'Settings',
      path: '/investor/settings',
      icon: <Settings size={20} data-id="element-374" />
    }];
    const farmerNavItems = [{
      name: 'Dashboard',
      path: '/farmer/dashboard',
      icon: <LayoutDashboard size={20} data-id="element-375" />
    }, {
      name: 'My Projects',
      path: '/farmer/projects',
      icon: <SproutIcon size={20} data-id="element-376" />
    }, {
      name: 'Funding',
      path: '/farmer/funding',
      icon: <DollarSign size={20} data-id="element-377" />
    }, {
      name: 'Progress Updates',
      path: '/farmer/progress',
      icon: <LineChart size={20} data-id="element-378" />,
      subItems: [{
        name: 'Add Update',
        path: '/farmer/progress/add'
      }, {
        name: 'View Updates',
        path: '/farmer/progress/view'
      }]
    }, {
      name: 'Calendar',
      path: '/farmer/calendar',
      icon: <Calendar size={20} data-id="element-379" />
    }, {
      name: 'Settings',
      path: '/farmer/settings',
      icon: <Settings size={20} data-id="element-380" />
    }];
    switch (userType) {
      case 'admin':
        return adminNavItems;
      case 'investor':
        return investorNavItems;
      case 'farmer':
        return farmerNavItems;
      default:
        return [];
    }
  };
  const toggleMenu = (path: string) => {
    if (expandedMenus.includes(path)) {
      setExpandedMenus(expandedMenus.filter(item => item !== path));
    } else {
      setExpandedMenus([...expandedMenus, path]);
    }
  };
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };
  const navItems = getNavigationItems();
  return <aside className="hidden lg:block w-64 bg-white border-r border-gray-200 h-[calc(100vh-64px)] overflow-y-auto sticky top-16" data-id="element-381">
      <div className="p-4" data-id="element-382">
        <nav className="space-y-1" data-id="element-383">
          {navItems.map(item => <div key={item.path} data-id="element-384">
              {item.subItems ? <div data-id="element-385">
                  <button onClick={() => toggleMenu(item.path)} className={`w-full flex items-center justify-between px-4 py-2 text-sm font-medium rounded-md ${isActive(item.path) ? 'text-leaf-green bg-leaf-green/10' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-386">
                    <div className="flex items-center" data-id="element-387">
                      <span className="mr-3" data-id="element-388">{item.icon}</span>
                      {item.name}
                    </div>
                    {expandedMenus.includes(item.path) ? <ChevronDown size={16} data-id="element-389" /> : <ChevronRight size={16} data-id="element-390" />}
                  </button>
                  {expandedMenus.includes(item.path) && <div className="mt-1 ml-6 pl-4 border-l border-gray-200 space-y-1" data-id="element-391">
                      {item.subItems.map(subItem => <Link key={subItem.path} to={subItem.path} className={`block px-4 py-2 text-sm rounded-md ${isActive(subItem.path) ? 'text-leaf-green bg-leaf-green/10' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-392">
                          {subItem.name}
                        </Link>)}
                    </div>}
                </div> : <Link to={item.path} className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${isActive(item.path) ? 'text-leaf-green bg-leaf-green/10' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-393">
                  <span className="mr-3" data-id="element-394">{item.icon}</span>
                  {item.name}
                </Link>}
            </div>)}
        </nav>
        <div className="mt-auto pt-4 border-t border-gray-200 mt-6" data-id="element-395">
          <Link to="/help" className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-100" data-id="element-396">
            <HelpCircle size={20} className="mr-3" data-id="element-397" />
            Help & Support
          </Link>
        </div>
      </div>
    </aside>;
};